import { Action, createReducer, on } from '@ngrx/store';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { CrudState, CrudStateObject } from '@wdx/clmi/api-services/models';
import * as favouritesActions from './favourites.actions';

export interface State {
    favourites?: CrudStateObject<SystemEntity>;
}

export const initialState: State = {
    favourites: {},
};

const reducerSetup = createReducer(
    initialState,

    on(
        favouritesActions.favourite,
        (state, props): State => ({
            ...state,
            favourites: {
                ...state.favourites,
                [props.id]: {
                    ...(state.favourites[props.id] ||
                        ({} as CrudState<SystemEntity>)),
                    isUpdating: true,
                    hasUpdatingError: false,
                },
            },
        }),
    ),

    on(
        favouritesActions.favouriteSuccess,
        (state, props): State => ({
            ...state,
            favourites: {
                ...state.favourites,
                [props.id]: {
                    ...(state.favourites[props.id] ||
                        ({} as CrudState<SystemEntity>)),
                    isUpdating: false,
                    hasUpdatingError: false,
                },
            },
        }),
    ),

    on(
        favouritesActions.favouriteFailure,
        (state, props): State => ({
            ...state,
            favourites: {
                ...state.favourites,
                [props.id]: {
                    ...(state.favourites[props.id] ||
                        ({} as CrudState<SystemEntity>)),
                    isUpdating: false,
                    hasUpdatingError: true,
                },
            },
        }),
    ),

    on(
        favouritesActions.unfavourite,
        (state, props): State => ({
            ...state,
            favourites: {
                ...state.favourites,
                [props.id]: {
                    ...(state.favourites[props.id] ||
                        ({} as CrudState<SystemEntity>)),
                    isUpdating: true,
                    hasUpdatingError: false,
                },
            },
        }),
    ),

    on(
        favouritesActions.unfavouriteSuccess,
        (state, props): State => ({
            ...state,
            favourites: {
                ...state.favourites,
                [props.id]: {
                    ...(state.favourites[props.id] ||
                        ({} as CrudState<SystemEntity>)),
                    isUpdating: false,
                    hasUpdatingError: false,
                },
            },
        }),
    ),

    on(
        favouritesActions.unfavouriteFailure,
        (state, props): State => ({
            ...state,
            favourites: {
                ...state.favourites,
                [props.id]: {
                    ...(state.favourites[props.id] ||
                        ({} as CrudState<SystemEntity>)),
                    isUpdating: false,
                    hasUpdatingError: true,
                },
            },
        }),
    ),
);

export function reducer(state: State | undefined, action: Action) {
    return reducerSetup(state, action);
}
